<template>
<div class="Delte-info">
    <vxe-modal v-model="dialogVisible" :before-hide-method="handleClose" width="50%" show-zoom resize transfer>
        <template #title>
            <span>题目批量删除</span>
        </template>
        <vxe-table :data="tableData" round border height="388" class="mytable-scrollbar" style="width: 100%" :highlight-current-row="true" ref="multipleTable" highlight-hover-row highlight-hover-column highlight-current-column show-overflow="tooltip" :tooltip-config="{enterable:true}" empty-text="没有更多数据了！" resizable stripe @current-change="currentChangeEvent" @checkbox-all="selectAllChangeEvent" @checkbox-change="handleSelectionChange">
            <vxe-table-column fixed="left" type="checkbox" title="全选" width="70"></vxe-table-column>
            <vxe-table-column fixed="left" type="seq" width="60" title="序号" align="center"></vxe-table-column>
            <vxe-table-column key="TipTile" field="title"  :title="title" align="center" show-overflow-tooltip />
        </vxe-table>
        <div class="option">
            <div>
                <span>已选中{{data.checkendSum}}</span>
            </div>
            <div>
                <el-button @click="handleClose">
                    <span>关闭</span>
                </el-button>
                <el-button @click="submit">
                    <span>确定</span>
                </el-button>
            </div>
        </div>
    </vxe-modal>
</div>
</template>

<script>
import {
    reactive,
    ref,
    computed,
    watch,
    onMounted,
    defineProps,
    defineEmits
} from "vue";
export default {
    emits: ["handleClose", "submit"],
    name: "DeleteQuestionnaire",
    props: {
        dialogVisible: {
            type: Boolean,
            required: true,
            default: false
        },
        DataList: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    setup(pro, content) {
        const data = reactive({
            // title:'qwqwqw',
            currentRow: null,
            multipleSelection: [],
            checkendSum: 0
        })

        const title=computed(()=>{
            return "总共"+ pro.DataList.length +"题"
        })

        const tableData=computed(()=>{
            console.log("tableData",pro.DataList)
            return pro.DataList
        })

        //关闭
        const handleClose = () => {
            content.emit('handleClose')
            resetData();
        }
        //确认
        const submit = () => {
            content.emit('submit', data.multipleSelection)
            resetData();
        }

        const currentChangeEvent = ({
            row,
            rowIndex
        }) => {
            data.currentRow = row;
        };
        const selectAllChangeEvent = ({
            checked,
            records
        }) => {
            data.multipleSelection = records;
            data.checkendSum = records.length;
        };

        const handleSelectionChange = ({
            records
        }) => {
            data.multipleSelection = records;
            data.checkendSum = records.length;
        };

        const resetData = () => {
            data.multipleSelection = [];
            data.checkendSum = 0;
            data.currentRow = null;
        }
        return {
            data,
            title,
            tableData,
            handleClose,
            submit,
            currentChangeEvent,
            selectAllChangeEvent,
            handleSelectionChange,
        };
    }
}

</script>

<style scoped lang="less">
    .option{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 20px;
      }
</style>
